import swatchGroupStyles from '@salesforce/retail-react-app/app/theme/components/project/swatch-group'
import {remCalc} from '../../_utils'

export default {
    ...swatchGroupStyles,
    baseStyle: {
        ...swatchGroupStyles.baseStyle(),
        swatchLabel: {
            marginBottom: remCalc(16),
        },
        swatchesWrapper: {
            overflowX: 'auto',
            whiteSpace: {base: 'nowrap', lg: 'wrap'},
            flexWrap: {base: 'nowrap', lg: 'wrap'},
            padding: remCalc(2),
        },
    },
    variants: {
        ...swatchGroupStyles.variants,
        image: ({size}: {size: string}) => ({
            swatch: {
                border: 'none',
                height: size === 'small' ? remCalc(58) : remCalc(80),
                width: size === 'small' ? remCalc(48) : remCalc(80),
                marginRight: remCalc(8),
                marginBottom: remCalc(8),
            },
            swatchButton: {
                border: 'none',
            },
        }),
        circle: () => ({
            swatch: {
                height: remCalc(48),
                width: remCalc(48),
                cursor: 'pointer',
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                borderRadius: 'full',
            },
            swatchButton: {
                minWidth: 'auto',
                marginRight: 0,
                height: '100%',
                width: '100%',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                _focus: {
                    outline: 'none',
                },
            },
        }),
    },
    parts: ['swatch', 'swatchButton'],
}
